import React, { useEffect, useState } from 'react'
import TicketHelp from './TicketHelp'
import Draggable from "react-draggable"
import { ResizableBox } from "react-resizable"
import Bug from "../../../../assets/images/flags/bug-icon.png"
import List from "../../../../assets/images/flags/bucket-list.png"
import Warning from "../../../../assets/images/flags/warning.png"
import AllTickets from './AllTickets'
import "../../../../assets/css/Work/support.css"
const Help = () => {
    const [ticket, setTicket] = useState(false)
    const [ticketList, setTicketList] = useState(false)
    const [boxWidth, setBoxWidth] = useState(0)
    const [ticketBoxWidth, setTicketBoxWidth] = useState(0)
    const [openOption, setOpenOption] = useState(false)
    useEffect(() => {
        const updateWidth = () => {
            const viewportWidth = window.innerWidth
            setBoxWidth(viewportWidth * 0.58)
            setTicketBoxWidth(viewportWidth * 0.90)
        }
        updateWidth()
        window.addEventListener("resize", updateWidth)
        return () => window.removeEventListener("resize", updateWidth)
    }, [])
    const closeModal = (modal) => {
        setTicket(modal)
    }
    const closeModalList = (modal) => {
        setTicketList(modal)
    }
    return (
        <div>
            <Draggable handle=".floating-button">
                <div className={`floating-container ${openOption ? 'show' : ''}`}>
                    <div className="floating-button" onClick={() => setOpenOption(!openOption)}>
                        <div className='position-absolute w-100 h-100'></div>
                        <img src={Bug} alt='Bug' width={32} height={32} />
                    </div>
                    {openOption ? (
                        <div className="element-container">
                            <a className="float-element" onClick={() => setTicketList(!ticketList)} title='All Reported Bugs'>
                                <img className='material-icons' src={List} alt='Bug' width={28} height={28} />
                            </a>
                            <a className="float-element" onClick={() => setTicket(!ticket)} title='Bug Report'>
                                <img className='smaterial-icons' src={Warning} alt='Bug' width={50} height={50} />
                            </a>
                        </div>
                    ) : null}
                </div>
            </Draggable>
            <div className={`note-sticky-form ${ticket ? "d-block" : "d-none"}`}>
                <Draggable handle=".modal-header" cancel=".modal-body">
                    <ResizableBox
                        width={boxWidth}
                        style={{
                            position: "fixed",
                            top: "16%",
                            right: "16%",
                            zIndex: "1055",
                            backgroundColor: "#fff",
                            maxHeight: "fit-content",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <div className="modal-header pe-4">
                            <h5 className="modal-title mt-0">Report an Issue or Provide Feedback</h5>
                            <button
                                type="button"
                                onClick={() => {
                                    setTicket(false)
                                }}
                                className="btn-modal-close"
                            >
                                <span aria-hidden="true" className="btn-modal-span">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <TicketHelp closeModal={closeModal} />
                    </ResizableBox>
                </Draggable>
            </div>
            <div className={`note-sticky-form ${ticketList ? "d-block" : "d-none"}`}>
                <Draggable handle=".modal-header" cancel=".modal-body">
                    <ResizableBox
                        width={ticketBoxWidth}
                        style={{
                            position: "fixed",
                            top: "16%",
                            right: "5%",
                            zIndex: "1055",
                            backgroundColor: "#fff",
                            maxHeight: "fit-content",
                            transform: "translate(-50%, -50%)",
                        }}
                    >
                        <div className="modal-header pe-4">
                            <h5 className="modal-title mt-0">All Reported Bugs & Suggestions</h5>
                            <button
                                type="button"
                                onClick={() => {
                                    setTicketList(false)
                                }}
                                className="btn-modal-close"
                            >
                                <span aria-hidden="true" className="btn-modal-span">
                                    &times;
                                </span>
                            </button>
                        </div>
                        <AllTickets closeModal={closeModalList} ticketList={ticketList} />
                    </ResizableBox>
                </Draggable>
            </div>
            
        </div>
    )
}

export default Help
